module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Edit image","select_mode_question":"How do you want to set your profile image?","create_avatar":"Create avatar","upload_image":"Upload image"},"de":{"title":"Bild bearbeiten","select_mode_question":"Wie möchtest du dein Profilbild setzen?","create_avatar":"Avatar erstellen","upload_image":"Bild hochladen"}}')
  delete Component.options._Ctor
}
